import EventMarker from "../EventMarker";
import {statuses} from "../../../Config";
import React from "react";
import {Grid} from "@material-ui/core";
import {DateFormat} from "../../../../../helpers/DateFormat";
import {Videocam} from "@material-ui/icons";
import purge from "../Purge"

const EVENT_TYPE = 0, DURATION = 1, CAMERA_CODE = 2, CAMERA_NAME = 3, DEVICE_CODE = 4,
    DEVICE_NAME = 5, DRIVER_CODE = 6, DRIVER_NAME = 7, DRIVER_2_CODE = 8, DRIVER_2_NAME = 9,
    CAMERA_EXTERNAL_ID = 10, METADATA = 11, LATITUDE = 12, LONGITUDE = 13, SPEED = 14,
    ACCURACY = 16, TIMESTAMP = 17

function getColour(eventType){
    switch (eventType){
        case "warning":
            return statuses.warning.colour
        case "stop":
            return statuses.faulty.colour
        default:
            return "#777"
    }
}

function getMarkerSvg(colour){
    return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
            <g transform="translate(2 5)">
                <path d="M4 5h17c2.2 0 4 1.8 4 4v11c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V9c0-2.2 1.8-4 4-4z" fill="${colour}"/>
                <path d="M25 12l8-5v15l-8-5z" fill="${colour}"/>
                <circle cx="12.5" cy="14.5" r="4.5" fill="#fff"/>
                <circle cx="12.5" cy="14.5" r="2.5" fill="${colour}"/>
            </g>
        </svg>
    `
}

function property(key, value){
    return (
        <React.Fragment key={key}>
            <Grid item xs={6}>
                <b>{key}</b>
            </Grid>
            <Grid item xs={6}>
                {value}
            </Grid>
        </React.Fragment>
    )
}

function toLabel(eventType){
    return eventType ? eventType.substring(0, 1).toUpperCase() + eventType.substring(1) : "Detection"
}

function eventType(event, classes){
    const type = event[EVENT_TYPE]
    return (
        <React.Fragment key="Type">
            <Grid item xs={6}>
                <b style={{color: getColour(type)}} className={classes.event}><Videocam/>{toLabel(type)}</b>
            </Grid>
            <Grid item xs={6}>
                {(new DateFormat(event[TIMESTAMP])).datetime()}
            </Grid>
        </React.Fragment>
    )
}

function namedDevice(name, code){
    if (name && code){
        return `${name} (${code})`
    }
    return purge(name || code)
}

function metadataSummary(metadata){
    if (!metadata){
        return "N/A"
    }
    const parts = []
    if (metadata.zone){
        parts.push(`Zone: ${metadata.zone}`)
    }
    if (metadata.confidence !== undefined && metadata.confidence !== null){
        parts.push(`Confidence: ${metadata.confidence}`)
    }
    if (metadata["object-count"] !== undefined && metadata["object-count"] !== null){
        parts.push(`Objects: ${metadata["object-count"]}`)
    }
    return parts.length ? parts.join(", ") : JSON.stringify(metadata)
}

function getPosition(row) {
    return EventMarker.latLng(row[LATITUDE], row[LONGITUDE])
}

export default {
    type: "camera",
    label: "Camera",
    getPosition: getPosition,
    getMarkers: (row) => {
        const position = getPosition(row)
        return position ? [new EventMarker(
            position,
            getMarkerSvg(getColour(row[EVENT_TYPE])),
            row[ACCURACY]
        )] : []
    },
    timestampOffset: TIMESTAMP,
    getProperties: (row, type, classes) => {
        return [
            eventType(row, classes),
            property("Camera", namedDevice(row[CAMERA_NAME], row[CAMERA_CODE])),
            property("Vehicle", namedDevice(row[DEVICE_NAME], row[DEVICE_CODE])),
            property("Driver", namedDevice(row[DRIVER_NAME], row[DRIVER_CODE])),
            property("Driver 2", namedDevice(row[DRIVER_2_NAME], row[DRIVER_2_CODE])),
            property("Duration", purge(row[DURATION], 's')),
            property("Speed", purge(row[SPEED], 'kph')),
            property("External ID", purge(row[CAMERA_EXTERNAL_ID])),
            property("Metadata", metadataSummary(row[METADATA]))
        ]
    }
}
